import { Hammer, Phone, MapPin, Mail, MessageCircle, Facebook, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function Footer() {
    const [s, setS] = useState(null);
    useEffect(() => {
        api.get("/settings").then((r) => setS(r.data)).catch(() => {});
    }, []);

    const wa = s?.whatsapp ? `https://wa.me/${s.whatsapp.replace(/[^0-9]/g, "")}` : null;

    return (
        <footer className="bg-[var(--lz-navy)] text-white mt-16" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-4 py-12 grid md:grid-cols-4 gap-8">
                <div>
                    <div className="flex items-center gap-2 mb-4">
                        <span className="inline-flex items-center justify-center w-8 h-8 bg-[var(--lz-orange)] text-[var(--lz-navy)]"><Hammer className="w-4 h-4" /></span>
                        <span className="font-display font-bold text-lg uppercase">{s?.business_name || "Ferretería Lozmar"}</span>
                    </div>
                    <p className="text-sm text-white/60 leading-relaxed">
                        {s?.tagline || "Productos y herramientas profesionales para construcción, plomería y eléctrico desde 1992."}
                    </p>
                    {(s?.facebook || s?.instagram) && (
                        <div className="flex gap-2 mt-4">
                            {s?.facebook && (
                                <a href={s.facebook} target="_blank" rel="noreferrer" className="p-2 border border-white/20 hover:bg-[var(--lz-orange)] hover:text-[var(--lz-navy)] hover:border-[var(--lz-orange)]" data-testid="footer-fb">
                                    <Facebook className="w-4 h-4" />
                                </a>
                            )}
                            {s?.instagram && (
                                <a href={s.instagram} target="_blank" rel="noreferrer" className="p-2 border border-white/20 hover:bg-[var(--lz-orange)] hover:text-[var(--lz-navy)] hover:border-[var(--lz-orange)]" data-testid="footer-ig">
                                    <Instagram className="w-4 h-4" />
                                </a>
                            )}
                        </div>
                    )}
                </div>
                <div>
                    <div className="text-xs font-bold uppercase tracking-[0.3em] text-[var(--lz-orange)] mb-4">Tienda</div>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/productos" className="hover:text-[var(--lz-orange)]">Catálogo</Link></li>
                        <li><Link to="/productos?featured=1" className="hover:text-[var(--lz-orange)]">Destacados</Link></li>
                        <li><Link to="/contacto" className="hover:text-[var(--lz-orange)]">Contacto</Link></li>
                        <li><Link to="/admin/login" className="hover:text-[var(--lz-orange)]">Acceso Admin</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="text-xs font-bold uppercase tracking-[0.3em] text-[var(--lz-orange)] mb-4">Contacto</div>
                    <ul className="space-y-2 text-sm text-white/80">
                        {s?.phone && (
                            <li className="flex gap-2 items-start"><Phone className="w-4 h-4 mt-0.5 text-[var(--lz-orange)]" /> <a href={`tel:${s.phone}`} className="hover:text-[var(--lz-orange)]">{s.phone}</a></li>
                        )}
                        {wa && (
                            <li className="flex gap-2 items-start"><MessageCircle className="w-4 h-4 mt-0.5 text-[var(--lz-orange)]" /> <a href={wa} target="_blank" rel="noreferrer" className="hover:text-[var(--lz-orange)]">WhatsApp</a></li>
                        )}
                        {s?.email && (
                            <li className="flex gap-2 items-start"><Mail className="w-4 h-4 mt-0.5 text-[var(--lz-orange)]" /> <a href={`mailto:${s.email}`} className="hover:text-[var(--lz-orange)]">{s.email}</a></li>
                        )}
                        {s?.address && (
                            <li className="flex gap-2 items-start"><MapPin className="w-4 h-4 mt-0.5 text-[var(--lz-orange)]" /> <span>{s.address}{s.city ? `, ${s.city}` : ""}</span></li>
                        )}
                    </ul>
                </div>
                <div>
                    <div className="text-xs font-bold uppercase tracking-[0.3em] text-[var(--lz-orange)] mb-4">Horario</div>
                    <ul className="space-y-1 text-sm text-white/80 font-mono">
                        {(s?.hours || []).map((h) => (
                            <li key={`${h.day}-${h.time}`} className="flex justify-between gap-2"><span>{h.day}</span><span>{h.time}</span></li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-4 py-4 text-xs uppercase tracking-widest text-white/50 flex flex-col md:flex-row md:justify-between gap-2">
                    <span>© {new Date().getFullYear()} {s?.business_name || "Ferretería Lozmar"}. Todos los derechos reservados.</span>
                    <span>Truper · DeWalt · Comex · CEMEX · Foset</span>
                </div>
            </div>
        </footer>
    );
}
